import { BaseUseCase } from "../../../../useCases/UseCaseBase";
class ExpiryDateUseCase extends BaseUseCase {
    constructor(optionRepo) {
        super();
        this.optionRepo = optionRepo;
    }
    async fetchResult() {
        return await this.optionRepo.getExpiryDateData();
    }
}
export default ExpiryDateUseCase;
